import { render, staticRenderFns } from "./DynamicRadio.vue?vue&type=template&id=d4022244&scoped=true&"
import script from "./DynamicRadio.vue?vue&type=script&lang=js&"
export * from "./DynamicRadio.vue?vue&type=script&lang=js&"
import style0 from "./DynamicRadio.vue?vue&type=style&index=0&id=d4022244&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4022244",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
